import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./lib/auth.js";
import { Layout } from "./components/Layout.js";
import { LoginPage } from "./pages/Login.js";
import { LoginVerifyPage } from "./pages/LoginVerify.js";
import { WorkspacesPage } from "./pages/Workspaces.js";
import { BulkIssuePage } from "./pages/BulkIssue.js";
import { DesignerPage } from "./pages/Designer.js";
import { WalletPage } from "./pages/Wallet.js";
import { ClaimPage } from "./pages/Claim.js";
import { AnalyticsPage } from "./pages/Analytics.js";
import { ResumesPage } from "./pages/Resumes.js";
import { ResumeEditPage } from "./pages/ResumeEdit.js";
import { SkillsPage } from "./pages/Skills.js";
import { CvListPage } from "./pages/CvList.js";
import { CvEditPage } from "./pages/CvEdit.js";
import { AccountPage } from "./pages/Account.js";

export function App() {
  const { me, loading } = useAuth();

  if (loading) {
    return <div className="grid h-full place-items-center text-sm text-muted-foreground">Loading…</div>;
  }

  return (
    <Routes>
      <Route path="/login" element={me ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/login/verify" element={<LoginVerifyPage />} />
      <Route path="/claim" element={<ClaimPage />} />
      {me ? (
        <Route element={<Layout />}>
          <Route path="/" element={<WorkspacesPage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/resumes" element={<ResumesPage />} />
          <Route path="/resumes/:id" element={<ResumeEditPage />} />
          <Route path="/skills" element={<SkillsPage />} />
          <Route path="/cv" element={<CvListPage />} />
          <Route path="/cv/:id" element={<CvEditPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/issuers/:slug/issuance" element={<BulkIssuePage />} />
          <Route path="/issuers/:slug/workspaces/:wsId/designer" element={<DesignerPage />} />
          <Route path="/issuers/:slug/workspaces/:wsId/designer/:templateId" element={<DesignerPage />} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
}
